import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LanguagesService } from 'src/app/services/language.service';
import { BaseService } from 'src/app/services/base.service';
import { IsraelyStatusComponent } from './israely-status.component';

  @Component({
    selector: 'partner-data',
    templateUrl: './partner-data.component.html'
  })
  export class PartnerDataComponent implements OnInit {
    @Input() form: FormGroup = null;
    @Input() Israely = false;
    @Output() onreset = new EventEmitter();
    @Output() activateMe = new EventEmitter();
    @Output() nextTab = new EventEmitter<any>();
    isSocialID_Mandarory = false;
    isSubmited = false;
    public _form: FormGroup = null;
    @ViewChild(IsraelyStatusComponent) private israelyStatusComponent: IsraelyStatusComponent;

    constructor (public languagesService: LanguagesService,
        public baseService: BaseService) {
        
    }

    ngOnInit(): void {
      this._form = this.form.controls.form_PartnerData as FormGroup;
      this._form.addControl('moia_donation', new FormControl(null, [Validators.required]));
      this._form.addControl('returning_donation', new FormControl(null, [Validators.required]));
    }

    public get f() {
        return this._form.controls;  
    }

    onReset() {
        this.israelyStatusComponent.onReset();
        this.onreset.emit();        
    }

    isValid() {
      let isValid = this.baseService.isFormDatesValid(this._form, 2) &&
        !this.baseService.isExistsSocialID_DuplicationsMessage(this.form);

      if (this._form.invalid || !isValid) {
        this._form.markAllAsTouched();
        this.activateMe.emit();
        return false;
      }
      return true;
    }

    onSubmit() {
      if (!this.isValid()) {
        return false;
      }
      this.isSubmited = true;
      return true;
    }    

    checkIsraelyStatus(event) {
      this.isSocialID_Mandarory = (event == 1);
    }
  }